if (!customElements.get('modal-dialog')) {
  customElements.define(
    'modal-dialog',
    class ModalDialog extends HTMLElement {
      constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener(
          'click',
          this.hide.bind(this, false)
        );
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
          this.addEventListener('pointerup', (event) => {
            if (event.target === this) this.hide();
          });
        } else {
          this.addEventListener('click', (event) => {
            if (event.target === this) this.hide();
          });
        }
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
      }

      hide() {
        this.removeAttribute('open');
        this.openedBy && this.openedBy.focus();
        document.body.classList.remove('overflow-hidden');
      }

      show(opener) {
        this.openedBy = opener;
        const targetModal = opener.getAttribute('data-modal');
        if (targetModal) this.id = targetModal;
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
      }
    }
  );
}